<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.deliveryNo"
        placeholder="快递单号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.contact"
        placeholder="联系人(电话、姓名)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.userId"
        placeholder="用户UID"
        style="width: 160px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.accountPhone"
        placeholder="账户手机号"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.sellerName"
        placeholder="卖家名称"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.supplierName"
        placeholder="供应商名称"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.goodsTitle"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in ORDER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.goodsType"
        placeholder="类型（可多选）"
        style="width: 200px"
        class="filter-item"
        multiple
        collapse-tags
        clearable
      >
        <el-option
          v-for="item in ORDER_FILTER_PRODUCT_TYPES"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.levelId"
        placeholder="用户类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in userLevelList"
          :key="item.id"
          :label="item.levelName"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.afterSaleStatus"
        placeholder="售后状态"
        style="width: 150px"
        class="filter-item"
        clearable
      >
        <el-option label="无售后" :value="-1" />
        <el-option
          v-for="item in AFTER_SALE_STATUS"
          :key="item.key"
          :label="formatAfterSaleLabel(item.value)"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        type="datetimerange"
        startPlaceholder="下单开始时间"
        endPlaceholder="下单截止时间"
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="pay"
        type="datetimerange"
        startPlaceholder="支付开始时间"
        endPlaceholder="支付截止时间"
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="delivery"
        type="datetimerange"
        startPlaceholder="发货开始时间"
        endPlaceholder="发货截止时间"
      />
      <ShopOption
        :refValue="listQuery.shopId"
        class="filter-item"
        type="formShop"
        :styleRef="{ width: '200px' }"
        @valueFunc="getShopValueFunc"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-truck"
        @click="openBatchDelivery"
        >批量处理未发货</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-upload2"
        @click="openOfflineImport"
        >导入订单</el-button
      >
    </div>
    <div style="display:flex; align-items: center;">
      <div style="margin-bottom: 5px">订单数量:{{ total }}</div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="userId"
        label="用户会员ID"
        width="190"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="orderNo"
        label="订单编号"
        width="190"
      ></el-table-column>
      <el-table-column
        label="联系姓名"
        align="center"
        prop="name"
        width="100"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        align="center"
        prop="phone"
        width="120"
      ></el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.modifyShippingAddressStatus === 1"
            type="warning"
            >修改地址中</el-tag
          >
          <el-tag v-else-if="scope.row.offlineActivityId" type="warning">{{
            scope.row.pickupStatus === 2
              ? "线下自取已领取"
              : scope.row.pickupStatus === 1
              ? "线下自取待领取"
              : "线下自取待支付"
          }}</el-tag>
          <el-tag
            v-else
            :color="getValue(ORDER_STATUS_CSS, scope.row.status)"
            style="color: #FFFFFF"
            >{{ getValue(ORDER_STATUS, scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="商品名称"
        prop="title"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ firstOrderItem(scope.row).title || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="卖家名称"
        align="center"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.sellerName || firstOrderItem(scope.row).sellerName || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="商品条目"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <div>
            {{
              firstOrderItem(scope.row).skuName ||
                firstOrderItem(scope.row).goodsSpece ||
                "-"
            }}
          </div>
          <div class="sku-spec" v-if="formatSkuSpec(firstOrderItem(scope.row))">
            {{ formatSkuSpec(firstOrderItem(scope.row)) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="拼团状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ getValue(GROUP_BUY_STATUS, scope.row.groupStatus) }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="售后状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag size="mini" effect="dark" :type="afterSaleTagType(scope.row)">
            {{ formatAfterSaleStatus(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="类型"
        prop="goodsType"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ getValue(PRODUCT_TYPE, firstOrderItem(scope.row).goodsType) }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="用户类型"
        prop="levelName"
        align="center"
        width="120"
      />
      <el-table-column
        label="支付订单号"
        align="center"
        prop="payNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="支付金额"
        align="center"
        prop="payAmount"
        width="100"
      ></el-table-column>
      <el-table-column
        class-name="status-col"
        label="支付方式"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag>{{
            getValue(ORDER_PAY_PLATFORM, scope.row.payPlatform)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="payTime"
        label="支付时间"
        width="150"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.payTime" />
          <span>{{ formatApiDate(scope.row.payTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="配送类型" align="center">
        <template slot-scope="scope">
          <el-tag
            :color="getValue(ORDER_POSTAGES_TYPE_CSS, scope.row.postagesType)"
            style="color: #FFFFFF"
            >{{ getValue(ORDER_POSTAGES_TYPE, scope.row.postagesType) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="运费金额"
        align="center"
        prop="postagesAmount"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="deliveryTime"
        label="发货时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.deliveryTime" />
          <span>{{ formatApiDate(scope.row.deliveryTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="能否申请售后"
        align="center"
        prop="isAfter"
      >
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.offlineActivityId
                ? 'info'
                : scope.row.isAfter
                ? 'success'
                : 'danger'
            "
            >{{
              scope.row.offlineActivityId
                ? "线下商品不支持"
                : scope.row.isAfter
                ? "能"
                : "否"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="takeTime"
        label="确认收货时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.takeTime" />
          <span>{{ formatApiDate(scope.row.takeTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="300"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="jumpInfo(scope.row, 'info')"
            class="comm_but_warp"
            >预览</el-button
          >
          <el-button
            type="warning"
            size="mini"
            plain
            :disabled="![0, 1, 2].includes(scope.row.status) || scope.row.isAfter"
            @click="openAddressDialog(scope.row)"
            class="comm_but_warp"
            >改地址</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            v-if="scope.row.groupStatus === 1 || scope.row.groupStatus === null"
            @click="
              !scope.row.isAfter &&
                scope.row.modifyShippingAddressStatus !== 1 &&
                checkShipmentsVisible(true, scope.row)
            "
            class="comm_but_warp"
            :disabled="
              ![2, 9].includes(scope.row.status) ||
                scope.row.isAfter ||
                scope.row.modifyShippingAddressStatus === 1
            "
            >发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    发货-->
    <el-dialog
      :title="
        currentShippingOrder && currentShippingOrder.status === 9
          ? '补充包裹'
          : '订单发货'
      "
      :visible.sync="shipmentsVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <el-form :model="goodsForm" label-position="top" class="delivery-form">
        <el-form-item label="实物商品">
          <el-table
            ref="multipleTable"
            :data="goodsList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            size="mini"
            v-loading="goodsListLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="商品编号" width="80">
            </el-table-column>
            <el-table-column prop="title" label="商品名称"> </el-table-column>
            <el-table-column prop="mainGraph" label="商品图" width="100">
              <template slot-scope="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.mainGraph"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="发货方式">
          <el-radio-group
            v-model="shippingMode"
            :disabled="
              currentShippingOrder && currentShippingOrder.status === 9
            "
            @change="changeShippingMode"
          >
            <el-radio label="single">单包裹</el-radio>
            <el-radio label="multi">多包裹</el-radio>
          </el-radio-group>
          <span
            v-if="currentShippingOrder && currentShippingOrder.status === 9"
            class="delivery-tip"
            >订单已部分发货，只能继续补充包裹</span
          >
        </el-form-item>
        <el-form-item v-if="shippingMode === 'multi'" label="计划包裹数量">
          <el-select
            v-model="packageCount"
            style="width: 180px"
            @change="changePackageCount"
          >
            <el-option
              v-for="count in 20"
              :key="count"
              :label="count + ' 个包裹'"
              :value="count"
            />
          </el-select>
          <span class="delivery-tip"
            >可先填写至少一个包裹，其余包裹后续补充</span
          >
        </el-form-item>
        <el-form-item v-if="shippingMode === 'multi'" label="统一快递公司">
          <div class="package-express-action">
            <el-select
              v-model="packageExpressId"
              label="统一快递公司"
              placeholder="请选择快递公司"
              clearable
              filterable
              :disabled="shipmentsBtnLoading || deliveryPackagesLoading"
            >
              <el-option
                v-for="item in shippingCompanyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-button
              type="primary"
              plain
              :disabled="!canApplyPackageExpress"
              @click="applyPackageExpress"
              >应用到全部未发货包裹</el-button
            >
          </div>
          <div class="package-express-tip">
            覆盖未发货包裹已选公司，不修改单号；未填单号的包裹仍待补充。点击底部“确定”后保存。
          </div>
        </el-form-item>
        <div class="package-list">
          <div
            v-for="(pkg, index) in deliveryPackages"
            :key="pkg.id || 'new-' + index"
            class="package-card"
          >
            <div class="package-card__header">
              <strong>包裹 {{ index + 1 }}</strong>
              <div>
                <el-tag v-if="pkg.status === 1" type="success" size="mini"
                  >已发货</el-tag
                >
                <el-tag v-else type="info" size="mini">待补充</el-tag>
                <el-button
                  v-if="
                    shippingMode === 'multi' &&
                      pkg.status !== 1 &&
                      deliveryPackages.length > 1
                  "
                  type="text"
                  class="package-delete"
                  @click="removePackage(index)"
                  >删除</el-button
                >
              </div>
            </div>
            <div class="package-card__fields">
              <el-select
                v-model="pkg.expressId"
                placeholder="请选择快递公司"
                clearable
                filterable
                :disabled="pkg.status === 1"
                @change="rememberExpressId"
              >
                <el-option
                  v-for="item in shippingCompanyOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-input
                v-model.trim="pkg.expressNo"
                placeholder="请输入快递单号"
                :disabled="pkg.status === 1"
              />
            </div>
          </div>
        </div>
        <el-button
          v-if="shippingMode === 'multi' && deliveryPackages.length < 20"
          plain
          icon="el-icon-plus"
          class="add-package"
          @click="addPackage"
          >添加包裹</el-button
        >
        <div class="delivery-note">
          已填写的包裹会立即发货；仍有空包裹时订单进入“部分已发货”，全部填写后进入“已发货”。
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkShipmentsVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="shipmentsOk"
          :loading="shipmentsBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="直接修改收货地址"
      :visible.sync="addressDialogVisible"
      :close-on-click-modal="false"
      width="620px"
      @closed="resetAddressForm"
    >
      <el-alert
        title="保存后立即更新订单地址，无需审核；系统会在改址审核列表中生成一条“已通过”记录。"
        type="warning"
        :closable="false"
        show-icon
        class="address-edit-alert"
      />
      <el-form ref="addressForm" :model="addressForm" :rules="addressRules" label-width="100px">
        <el-form-item label="收货人" prop="name">
          <el-input v-model.trim="addressForm.name" maxlength="40" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="addressForm.phone" maxlength="30" />
        </el-form-item>
        <el-form-item label="所在地区" prop="regionIds">
          <CascadeRegion
            :key="addressRegionKey"
            :value="addressForm.regionIds"
            type="orderAddressRegion"
            :styleRef="{ width: '100%' }"
            @valueFunc="handleAddressRegionChange"
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model.trim="addressForm.address"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addressDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addressSaving" @click="submitAddressModify">
          保存并通过
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量处理未发货"
      :visible.sync="batchDeliveryVisible"
      :close-on-click-modal="false"
      width="78%"
    >
      <el-alert
        title="仅查询并处理当前商户的待发货订单；存在待审核改址申请的订单不能发货。"
        type="info"
        :closable="false"
        show-icon
      />
      <el-form
        :inline="true"
        :model="batchQuery"
        :disabled="batchSubmitting || batchQueryLoading"
        class="batch-query-form"
        size="small"
      >
        <el-form-item label="订单号">
          <el-input
            v-model.trim="batchQuery.orderNos"
            clearable
            placeholder="支持多个订单号"
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="卖家名称">
          <el-input
            v-model.trim="batchQuery.sellerName"
            clearable
            placeholder="请输入卖家名称"
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
            v-model.trim="batchQuery.goodsTitle"
            clearable
            placeholder="请输入商品名称"
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="batchPayTimeRange"
            type="datetimerange"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            range-separator="至"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="queryPendingDelivery">搜索</el-button>
          <el-button @click="resetBatchQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="batch-delivery-toolbar">
        <span>已自动识别 {{ batchDeliveryRows.length }} 笔待发货订单</span>
        <div class="batch-express-action">
          <span>已选 {{ batchSelectedRows.length }} 笔</span>
          <el-select
            v-model="batchExpressId"
            filterable
            clearable
            :disabled="batchSubmitting || batchQueryLoading"
            placeholder="批量选择快递公司"
            style="width: 210px"
          >
            <el-option
              v-for="item in shippingCompanyOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-button
            type="primary"
            plain
            :disabled="batchSubmitting || batchQueryLoading || !batchExpressId || !batchSelectedRows.length"
            @click="applyBatchExpress"
            >应用到选中订单</el-button
          >
        </div>
      </div>
      <el-table
        ref="batchDeliveryTable"
        v-loading="batchQueryLoading"
        :data="pagedBatchDeliveryRows"
        row-key="id"
        border
        size="small"
        style="margin-top: 16px"
        @selection-change="handleBatchSelectionChange"
      >
        <el-table-column
          type="selection"
          width="48"
          :reserve-selection="true"
          :selectable="canSelectBatchOrder"
        />
        <el-table-column prop="orderNo" label="订单号" min-width="190" />
        <el-table-column label="用户" width="120"
          ><template slot-scope="scope">{{
            scope.row.userId
          }}</template></el-table-column
        >
        <el-table-column label="商品" min-width="180"
          ><template slot-scope="scope">{{
            firstOrderItem(scope.row).title || "-"
          }}</template></el-table-column
        >
        <el-table-column label="卖家名称" min-width="140">
          <template slot-scope="scope">{{ firstOrderItem(scope.row).sellerName || "-" }}</template>
        </el-table-column>
        <el-table-column label="支付时间" min-width="155">
          <template slot-scope="scope">{{ formatApiDate(scope.row.payTime) }}</template>
        </el-table-column>
        <el-table-column label="快递公司" min-width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.expressId"
              filterable
              clearable
              :disabled="batchSubmitting || scope.row.batchSuccess"
              placeholder="选择快递公司"
              style="width: 100%"
              @change="rememberExpressId"
            >
              <el-option
                v-for="item in shippingCompanyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="快递单号" min-width="190">
          <template slot-scope="scope"
            ><el-input
              v-model.trim="scope.row.expressNo"
              placeholder="填写快递单号"
              :disabled="batchSubmitting || scope.row.batchSuccess"
          /></template>
        </el-table-column>
        <el-table-column prop="batchMessage" label="处理结果" min-width="160" />
      </el-table>
      <div class="batch-delivery-pagination">
        <el-pagination
          :current-page.sync="batchDeliveryPage"
          :page-size="batchDeliveryPageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          :total="batchDeliveryRows.length"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleBatchDeliverySizeChange"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDeliveryVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="batchSubmitting"
          :disabled="batchQueryLoading || !batchSelectedRows.length"
          @click="submitBatchDelivery"
          >确认发货（{{ batchSelectedRows.length }} 笔）</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="导入线下订单"
      :visible.sync="offlineImportVisible"
      :close-on-click-modal="false"
      width="680px"
    >
      <el-alert
        title="线下购买订单无需发货"
        description="确认导入后，系统会创建已支付订单并直接执行确认收货流程，随后按现有规则发放贡献值、抽奖次数等订单奖励。"
        type="warning"
        :closable="false"
        show-icon
      />
      <div class="offline-import-actions">
        <el-button icon="el-icon-download" @click="downloadOfflineTemplate"
          >下载导入模板</el-button
        >
        <el-upload
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          accept=".xls,.xlsx,.csv"
          :on-change="selectOfflineFile"
        >
          <el-button type="primary" icon="el-icon-folder-opened"
            >选择文件</el-button
          >
        </el-upload>
      </div>
      <div v-if="offlineImportFile" class="selected-import-file">
        <i class="el-icon-document" />
        <span>{{ offlineImportFile.name }}</span>
        <el-button type="text" @click="offlineImportFile = null"
          >移除</el-button
        >
      </div>
      <el-table
        v-if="offlineImportResults.length"
        :data="offlineImportResults"
        border
        size="small"
        max-height="300"
        style="margin-top: 16px"
      >
        <el-table-column prop="rowNo" label="行号" width="70" />
        <el-table-column prop="orderNo" label="生成订单号" min-width="190" />
        <el-table-column label="状态" width="90"
          ><template slot-scope="scope"
            ><el-tag :type="scope.row.success ? 'success' : 'danger'">{{
              scope.row.success ? "成功" : "失败"
            }}</el-tag></template
          ></el-table-column
        >
        <el-table-column prop="message" label="结果" min-width="220" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="offlineImportVisible = false">关闭</el-button>
        <el-button
          type="primary"
          :loading="offlineImportLoading"
          :disabled="!offlineImportFile"
          @click="confirmOfflineImport"
          >确认导入并确认收货</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderList,
  getGoodsList,
  getDeliveryPackages,
  saveDeliveryPackages,
  exportOrderList,
  getPendingDeliveryOrders,
  batchDelivery,
  importOfflineOrders,
  directModifyAddress,
} from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  ORDER_STATUS,
  ORDER_POSTAGES_TYPE,
  ORDER_PAY_PLATFORM,
  PRODUCT_TYPE,
  AFTER_SALE_STATUS,
  GROUP_BUY_STATUS,
} from "@/utils/enumUtile";
import { getExpress } from "@/api/common";
import {
  ORDER_STATUS_CSS,
  ORDER_POSTAGES_TYPE_CSS,
} from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";
import { uploadXlsx } from "@/utils";
import ShopOption from "@/views/components/shopOption.vue";
import CascadeRegion from "@/views/components/cascadeRegion.vue";
import { getUserLevelList } from "@/api/member";

const LAST_EXPRESS_STORAGE_KEY = "tb-admin:last-express-id";

export default {
  computed: {
    canApplyPackageExpress() {
      return this.shippingMode === "multi" &&
        !this.shipmentsBtnLoading && !this.deliveryPackagesLoading && !this.deliveryPackagesLoadFailed &&
        this.shippingCompanyOption.some(item => String(item.id) === String(this.packageExpressId)) &&
        this.deliveryPackages.some(pkg => Number(pkg.status) !== 1);
    },
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_STATUS() {
      return ORDER_STATUS;
    },
    GROUP_BUY_STATUS() {
      return GROUP_BUY_STATUS;
    },
    ORDER_POSTAGES_TYPE() {
      return ORDER_POSTAGES_TYPE;
    },
    ORDER_PAY_PLATFORM() {
      return ORDER_PAY_PLATFORM;
    },
    ORDER_STATUS_CSS() {
      return ORDER_STATUS_CSS;
    },
    ORDER_POSTAGES_TYPE_CSS() {
      return ORDER_POSTAGES_TYPE_CSS;
    },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    },
    ORDER_FILTER_PRODUCT_TYPES() {
      return [
        { key: 1, value: "优选区" },
        { key: 2, value: "平价区" },
        { key: 3, value: "积分兑换" },
      ];
    },
    AFTER_SALE_STATUS() {
      return AFTER_SALE_STATUS.filter((item) => item.key >= 0 && item.key <= 8);
    },
    pagedBatchDeliveryRows() {
      const start = (this.batchDeliveryPage - 1) * this.batchDeliveryPageSize;
      return this.batchDeliveryRows.slice(
        start,
        start + this.batchDeliveryPageSize,
      );
    },
  },
  components: { ShopOption, DataPicker, CascadeRegion },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        orderNo: null,
        deliveryNo: null,
        contact: null,
        userId: null,
        accountPhone: null,
        sellerName: null,
        supplierName: null,
        afterSaleStatus: null,
        goodsType: [],
        goodsTitle: null,
        status: null,
        createStartTime: null,
        createEndTime: null,
        payStartTime: null,
        payEndTime: null,
        deliveryStartTime: null,
        deliveryEndTime: null,
        shopId: null,
      },
      shipmentsVisible: false,
      goodsList: [],
      goodsListLoading: false,
      goodsForm: {
        id: 0,
        itemIds: null,
      },
      currentShippingOrder: null,
      shippingMode: "single",
      packageCount: 1,
      packageExpressId: null,
      deliveryPackagesLoading: false,
      deliveryPackagesLoadFailed: false,
      deliveryPackagesRequestId: 0,
      deliveryPackages: [
        { id: null, expressId: null, expressNo: "", status: 0 },
      ],
      shipmentsBtnLoading: false,
      shippingCompanyOption: [], // 发货公司
      userLevelList: [],
      batchDeliveryVisible: false,
      batchDeliveryRows: [],
      batchDeliveryPage: 1,
      batchDeliveryPageSize: 10,
      batchQueryLoading: false,
      batchSubmitting: false,
      batchSelectedRows: [],
      batchExpressId: null,
      batchPayTimeRange: [],
      batchQuery: {
        orderNos: "",
        sellerName: "",
        goodsTitle: "",
      },
      addressDialogVisible: false,
      addressSaving: false,
      addressRegionKey: 0,
      addressForm: {
        orderId: null,
        name: "",
        phone: "",
        regionIds: [],
        countryId: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        townshipId: null,
        address: "",
      },
      addressRules: {
        name: [{ required: true, message: "请输入收货人姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        regionIds: [
          { required: true, type: "array", min: 3, message: "请选择到城市", trigger: "change" },
        ],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
      },
      offlineImportVisible: false,
      offlineImportFile: null,
      offlineImportLoading: false,
      offlineImportResults: [],
    };
  },
  created() {
    const savedState = sessionStorage.getItem("pageState");
    // 只有当 savedState 存在且是有效的 JSON 字符串时才恢复状态
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      // 确保解析后的数据是对象类型
      if (parsedState && typeof parsedState === "object") {
        this.listQuery = { ...this.listQuery, ...parsedState };
        const savedGoodsTypes = Array.isArray(this.listQuery.goodsType)
          ? this.listQuery.goodsType
          : [this.listQuery.goodsType];
        this.listQuery.goodsType = savedGoodsTypes
          .map(Number)
          .filter((goodsType) => [1, 2, 3].includes(goodsType));
      }
    }
    sessionStorage.removeItem("pageState");
    this.getShippingCompany();
    this.getList();
    this.getLevelList();
  },
  watch: {},
  methods: {
    getValue,
    firstOrderItem(row) {
      return row && row.items && row.items.length ? row.items[0] : {};
    },
    formatAfterSaleLabel(value) {
      if (!value) {
        return "售后处理中";
      }
      return value.indexOf("售后") === 0 ? value : `售后${value}`;
    },
    formatAfterSaleStatus(row) {
      if (
        row &&
        row.afterSaleStatus !== null &&
        row.afterSaleStatus !== undefined
      ) {
        const item = AFTER_SALE_STATUS.find(
          (status) => status.key === Number(row.afterSaleStatus),
        );
        return item ? this.formatAfterSaleLabel(item.value) : "售后处理中";
      }
      return row && row.isAfter ? "售后处理中" : "无售后";
    },
    afterSaleTagType(row) {
      if (!row || (row.afterSaleStatus === null && !row.isAfter)) return "info";
      const status = Number(row.afterSaleStatus);
      if (status === 7) return "success";
      if (status === 8) return "info";
      if (status === 6) return "danger";
      return "warning";
    },
    readLastExpressId() {
      try {
        const value = localStorage.getItem(LAST_EXPRESS_STORAGE_KEY);
        const company = this.shippingCompanyOption.find((item) => String(item.id) === value);
        return company ? company.id : null;
      } catch (e) {
        return null;
      }
    },
    rememberExpressId(expressId) {
      if (!expressId) return;
      try {
        localStorage.setItem(LAST_EXPRESS_STORAGE_KEY, String(expressId));
      } catch (e) {
        // 浏览器禁用本地存储时不影响发货主流程。
      }
    },
    formatSkuSpec(row) {
      if (!row || !row.specValuePath) {
        return "";
      }
      try {
        const spec = JSON.parse(row.specValuePath);
        return Object.keys(spec)
          .map((key) => `${key}: ${spec[key]}`)
          .join("; ");
      } catch (e) {
        return row.goodsSpece || "";
      }
    },
    /**
     * 查询用户等级列表
     */
    getLevelList() {
      getUserLevelList()
        .then((response) => {
          this.userLevelList = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 获取店铺
     * @param type
     * @param resultArr
     */
    getShopValueFunc(type, resultArr) {
      if (type === "formShop") {
        this.listQuery.shopId = resultArr;
      }
    },
    /**
     * 查询发货公司
     */
    getShippingCompany() {
      getExpress().then((resp) => {
        if (resp && resp.bizcode === 100) {
          this.shippingCompanyOption = resp.data;
        }
      });
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
      };
      getOrderList(params)
        .then((response) => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到其他页面
     */
    jumpInfo(item) {
      sessionStorage.setItem("pageState", JSON.stringify(this.listQuery));
      this.$router.push({ path: "/order/list/info/" + item.id });
    },

    // 发货 start
    checkShipmentsVisible(status, item) {
      if (status) {
        this.resetDeliveryForm();
        this.currentShippingOrder = item;
        this.deliveryPackages[0].expressId = this.readLastExpressId();
        this.packageExpressId = this.deliveryPackages[0].expressId;
        this.goodsForm.id = item.id;
        this.getGoodsList(item.id);
        if (item.status === 9) {
          this.shippingMode = "multi";
          this.loadDeliveryPackages(item.id);
        }
      } else {
        this.resetDeliveryForm();
      }
      this.shipmentsVisible = status;
    },
    emptyPackage() {
      return {
        id: null,
        expressId: null,
        expressNo: "",
        status: 0,
      };
    },
    resetDeliveryForm() {
      this.goodsForm = { id: 0, itemIds: null };
      this.currentShippingOrder = null;
      this.goodsList = [];
      this.shippingMode = "single";
      this.packageCount = 1;
      this.packageExpressId = null;
      this.deliveryPackagesLoading = false;
      this.deliveryPackagesLoadFailed = false;
      // 关闭或切换订单后，旧包裹请求不能覆盖新订单的批量设置。
      this.deliveryPackagesRequestId++;
      this.deliveryPackages = [this.emptyPackage()];
    },
    loadDeliveryPackages(orderId) {
      const requestId = ++this.deliveryPackagesRequestId;
      this.deliveryPackagesLoading = true;
      this.deliveryPackagesLoadFailed = false;
      return getDeliveryPackages({ id: orderId }).then((resp) => {
        if (requestId !== this.deliveryPackagesRequestId) return;
        if (!resp || resp.bizcode !== 100) {
          this.deliveryPackagesLoadFailed = true;
          this.$message.warning((resp && resp.msg) || "包裹加载失败，请重新打开后重试");
          return;
        }
        const packages = resp.data || [];
        if (packages.length) {
          this.deliveryPackages = packages.map((item) => ({ ...item }));
          this.shippingMode = packages.length > 1 ? "multi" : "single";
          this.packageCount = packages.length;
        }
      }).catch(() => {
        if (requestId === this.deliveryPackagesRequestId) {
          this.deliveryPackagesLoadFailed = true;
          this.$message.warning("包裹加载失败，请重新打开后重试");
        }
      }).finally(() => {
        if (requestId === this.deliveryPackagesRequestId) this.deliveryPackagesLoading = false;
      });
    },
    applyPackageExpress() {
      if (this.shippingMode !== "multi" || this.shipmentsBtnLoading || this.deliveryPackagesLoading || this.deliveryPackagesLoadFailed) return;
      const company = this.shippingCompanyOption.find(item => String(item.id) === String(this.packageExpressId));
      if (!company) {
        this.$message.warning("请先选择有效的快递公司");
        return;
      }
      // 仅更新当前表单的待发包裹，不触碰已发物流、包裹身份和各自单号。
      const pending = this.deliveryPackages.filter(pkg => Number(pkg.status) !== 1);
      if (!pending.length) {
        this.$message.warning("没有可设置的未发货包裹");
        return;
      }
      pending.forEach(pkg => { this.$set(pkg, "expressId", company.id); });
      this.rememberExpressId(company.id);
      this.$message.success(`已为 ${pending.length} 个未发货包裹设置快递公司，点击确定后保存`);
    },
    changeShippingMode(mode) {
      if (mode === "single") {
        this.deliveryPackages = [
          this.deliveryPackages[0] || this.emptyPackage(),
        ];
        this.packageCount = 1;
      } else {
        this.packageCount = Math.max(2, this.deliveryPackages.length);
        this.changePackageCount(this.packageCount);
      }
    },
    changePackageCount(count) {
      const target = Number(count);
      while (this.deliveryPackages.length < target)
        this.deliveryPackages.push(this.emptyPackage());
      if (this.deliveryPackages.length > target) {
        const removable = this.deliveryPackages
          .slice(target)
          .every((pkg) => pkg.status !== 1 && !pkg.expressId && !pkg.expressNo);
        if (!removable) {
          this.packageCount = this.deliveryPackages.length;
          this.$message.warning("已填写或已发货的包裹不能通过减少数量删除");
          return;
        }
        this.deliveryPackages.splice(target);
      }
    },
    addPackage() {
      if (this.deliveryPackages.length >= 20) return;
      this.deliveryPackages.push(this.emptyPackage());
      this.packageCount = this.deliveryPackages.length;
    },
    removePackage(index) {
      const pkg = this.deliveryPackages[index];
      if (pkg && pkg.status === 1) {
        this.$message.warning("已发货包裹不能删除");
        return;
      }
      this.deliveryPackages.splice(index, 1);
      this.packageCount = this.deliveryPackages.length;
    },
    /**
     * 查询订单详情
     */
    getGoodsList(id) {
      this.goodsListLoading = true;
      const params = {
        id,
      };
      getGoodsList(params)
        .then((resp) => {
          this.goodsList = resp.data;
          this.$nextTick(() => {
            (this.goodsList || []).forEach((row) => {
              if (this.$refs.multipleTable)
                this.$refs.multipleTable.toggleRowSelection(row, true);
            });
          });
        })
        .finally(() => {
          this.goodsListLoading = false;
        });
    },
    /**
     * 选择发货商品
     * @param item
     */
    handleSelectionChange(item) {
      this.goodsForm.itemIds = item.map((o) => o.id).join(",");
    },
    shipmentsOk() {
      if (this.shipmentsBtnLoading || this.deliveryPackagesLoading) return;
      if (this.deliveryPackagesLoadFailed) {
        this.$message.warning("包裹加载失败，请重新打开后重试");
        return;
      }
      if (!this.goodsForm.itemIds) {
        this.$message.warning("请选择需要发货的商品");
        return;
      }
      const packages =
        this.shippingMode === "single"
          ? this.deliveryPackages.slice(0, 1)
          : this.deliveryPackages;
      const incomplete = packages.find(
        (pkg) =>
          (this.shippingMode === "single" && pkg.expressId && !pkg.expressNo) ||
          (!pkg.expressId && pkg.expressNo),
      );
      if (incomplete) {
        this.$message.warning("同一包裹的快递公司和快递单号必须同时填写");
        return;
      }
      const completed = packages.filter(
        (pkg) => pkg.expressId && pkg.expressNo,
      );
      if (!completed.length) {
        this.$message.warning("请至少完整填写一个包裹");
        return;
      }
      this.shipmentsBtnLoading = true;
      saveDeliveryPackages({
        orderId: this.goodsForm.id,
        itemIds: this.goodsForm.itemIds,
        mode: this.shippingMode === "multi" ? 2 : 1,
        packages: packages.map((pkg) => ({
          id: pkg.id || null,
          // 多包裹统一预选公司并不代表已发货；无单号时仍以空占位提交。
          expressId: pkg.expressNo ? (pkg.expressId || null) : null,
          expressNo: pkg.expressNo || "",
        })),
      })
        .then((resp) => {
          if (resp && resp.bizcode === 100) {
            this.getList();
            this.checkShipmentsVisible(false);
            this.$notify({
              title: "成功",
              message:
                resp.data === 9
                  ? "已部分发货，可后续补充包裹"
                  : "订单已全部发货",
              type: "success",
              duration: 2500,
            });
          }
        })
        .finally(() => {
          this.shipmentsBtnLoading = false;
        });
    },
    // 发货 end
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      } else if (type === "pay") {
        this.listQuery.payStartTime = value[0];
        this.listQuery.payEndTime = value[1];
      } else if (type === "delivery") {
        this.listQuery.deliveryStartTime = value[0];
        this.listQuery.deliveryEndTime = value[1];
      }
    },

    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form,
      };
      exportOrderList(params).then((response) => {
        uploadXlsx(response, "订单表");
      });
    },
    openBatchDelivery() {
      this.clearBatchSelection();
      this.batchDeliveryVisible = true;
      this.batchDeliveryRows = [];
      this.batchDeliveryPage = 1;
      this.batchSelectedRows = [];
      this.batchExpressId = this.readLastExpressId();
      this.queryPendingDelivery();
    },
    queryPendingDelivery() {
      if (this.batchQueryLoading || this.batchSubmitting) return Promise.resolve();
      this.batchQueryLoading = true;
      const params = {
        ...this.batchQuery,
        payStartTime: this.batchPayTimeRange && this.batchPayTimeRange[0],
        payEndTime: this.batchPayTimeRange && this.batchPayTimeRange[1],
      };
      return getPendingDeliveryOrders(params)
        .then((response) => {
          if (!response || response.bizcode !== 100) return;
          this.clearBatchSelection();
          this.batchDeliveryRows = (response.data || []).map((item) => ({
            ...item,
            expressId: null,
            expressNo: "",
            batchMessage: "",
            batchSuccess: false,
          }));
          this.batchDeliveryPage = 1;
          if (!this.batchDeliveryRows.length)
            this.$message.warning("没有查到符合条件的待发货订单");
        })
        .finally(() => {
          this.batchQueryLoading = false;
        });
    },
    handleBatchDeliverySizeChange(size) {
      this.batchDeliveryPageSize = size;
      this.batchDeliveryPage = 1;
    },
    handleBatchSelectionChange(rows) {
      this.batchSelectedRows = rows || [];
    },
    clearBatchSelection() {
      if (this.$refs.batchDeliveryTable) this.$refs.batchDeliveryTable.clearSelection();
      this.batchSelectedRows = [];
    },
    canSelectBatchOrder(row) {
      return !this.batchSubmitting && !row.batchSuccess;
    },
    applyBatchExpress() {
      if (this.batchSubmitting || !this.batchExpressId || !this.batchSelectedRows.length) return;
      this.batchSelectedRows.forEach((row) => {
        this.$set(row, "expressId", this.batchExpressId);
      });
      this.rememberExpressId(this.batchExpressId);
      this.$message.success(`已为 ${this.batchSelectedRows.length} 笔订单设置快递公司`);
    },
    resetBatchQuery() {
      this.batchQuery = { orderNos: "", sellerName: "", goodsTitle: "" };
      this.batchPayTimeRange = [];
      this.queryPendingDelivery();
    },
    submitBatchDelivery() {
      if (this.batchSubmitting || this.batchQueryLoading) return Promise.resolve();
      const selectedIds = new Set(this.batchSelectedRows.map((row) => String(row.id)));
      const selectedRows = this.batchDeliveryRows
        .filter((row) => selectedIds.has(String(row.id)) && !row.batchSuccess)
        .map((row) => ({ ...row }));
      if (!selectedRows.length) {
        this.$message.warning("请先勾选需要发货的订单");
        return;
      }
      const invalid = selectedRows.find(
        (item) => !item.expressId || !item.expressNo,
      );
      if (invalid) {
        this.$message.warning(
          `订单 ${invalid.orderNo} 的快递公司或快递单号未填写`,
        );
        return;
      }
      this.batchSubmitting = true;
      return batchDelivery({
        deliveries: selectedRows.map((item) => ({
          orderId: item.id,
          expressId: item.expressId,
          expressNo: item.expressNo,
        })),
      })
        .then((response) => {
          if (!response || response.bizcode !== 100) return;
          const results = response.data || [];
          let successCount = 0;
          selectedRows.forEach((submitted) => {
            const row = this.batchDeliveryRows.find((item) => String(item.id) === String(submitted.id));
            if (!row) return;
            const result = results.find((item) => String(item.orderId) === String(row.id));
            this.$set(row, "batchMessage", result ? result.message : "未处理");
            this.$set(row, "batchSuccess", !!(result && result.success));
            if (row.batchSuccess) {
              successCount += 1;
              if (this.$refs.batchDeliveryTable) {
                this.$refs.batchDeliveryTable.toggleRowSelection(row, false);
              }
            }
          });
          this.batchSelectedRows = this.batchSelectedRows.filter((row) => !row.batchSuccess);
          const failedCount = selectedRows.length - successCount;
          const message = `批量处理完成，成功 ${successCount} 笔，失败 ${failedCount} 笔`;
          if (failedCount) this.$message.warning(message);
          else this.$message.success(message);
          if (successCount) this.getList();
        })
        .finally(() => {
          this.batchSubmitting = false;
        });
    },
    openAddressDialog(row) {
      const regionIds = [
        row.countryId,
        row.provinceId,
        row.cityId,
        row.areaId,
        row.townshipId,
      ].filter((value) => value !== null && value !== undefined && value !== "");
      this.addressForm = {
        orderId: row.id,
        name: row.name || "",
        phone: row.phone || "",
        regionIds,
        countryId: row.countryId || null,
        provinceId: row.provinceId || null,
        cityId: row.cityId || null,
        areaId: row.areaId || null,
        townshipId: row.townshipId || null,
        address: row.address || "",
      };
      this.addressRegionKey += 1;
      this.addressDialogVisible = true;
    },
    handleAddressRegionChange(type, regionIds) {
      if (type !== "orderAddressRegion") return;
      const values = regionIds || [];
      this.addressForm.regionIds = values;
      this.addressForm.countryId = values[0] || null;
      this.addressForm.provinceId = values[1] || null;
      this.addressForm.cityId = values[2] || null;
      this.addressForm.areaId = values[3] || null;
      this.addressForm.townshipId = values[4] || null;
      if (this.$refs.addressForm) this.$refs.addressForm.validateField("regionIds");
    },
    resetAddressForm() {
      if (this.$refs.addressForm) this.$refs.addressForm.clearValidate();
    },
    submitAddressModify() {
      this.$refs.addressForm.validate((valid) => {
        if (!valid) return;
        this.addressSaving = true;
        const { regionIds, ...payload } = this.addressForm;
        directModifyAddress(payload)
          .then((response) => {
            if (response && response.bizcode === 100) {
              this.$message.success("收货地址已修改，并已生成审核通过记录");
              this.addressDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.addressSaving = false;
          });
      });
    },
    openOfflineImport() {
      this.offlineImportVisible = true;
      this.offlineImportFile = null;
      this.offlineImportResults = [];
    },
    selectOfflineFile(file) {
      const raw = file && file.raw;
      const name = raw && raw.name ? raw.name.toLowerCase() : "";
      if (!/\.(xls|xlsx|csv)$/.test(name)) {
        this.$message.error("仅支持 .xls、.xlsx、.csv 文件");
        return;
      }
      this.offlineImportFile = raw;
      this.offlineImportResults = [];
    },
    downloadOfflineTemplate() {
      const link = document.createElement("a");
      link.href = `${process.env.BASE_URL ||
        "/"}templates/线下订单导入模板.xlsx`;
      link.download = "线下订单导入模板.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    confirmOfflineImport() {
      this.$confirm(
        "导入后将直接确认收货并进入奖励发放流程，且不需要发货。确认继续？",
        "确认导入线下订单",
        {
          confirmButtonText: "确认导入",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.offlineImportLoading = true;
          return importOfflineOrders(this.offlineImportFile)
            .then((response) => {
              this.offlineImportResults = response.data || [];
              const successCount = this.offlineImportResults.filter(
                (item) => item.success,
              ).length;
              const failCount = this.offlineImportResults.length - successCount;
              this.$message({
                type: failCount ? "warning" : "success",
                message: `导入完成：成功 ${successCount} 笔，失败 ${failCount} 笔`,
              });
              this.getList();
            })
            .finally(() => {
              this.offlineImportLoading = false;
            });
        })
        .catch((action) => {
          if (action !== "cancel" && action !== "close")
            this.$message.error((action && action.message) || "导入失败");
        });
    },
  },
};
</script>
<style scoped lang="scss">
.comm_but_warp {
  margin-bottom: 10px;
}

.filter-container {
  display: flex;
  /* 使用 flex 布局 */
  flex-wrap: wrap;
  /* 允许内容换行 */
  align-items: center;
  /* 垂直居中对齐 */
  gap: 10px;
  /* 元素之间的间距（现代浏览器支持） */
  margin-bottom: 20px;
  flex-direction: row;

  // 针对 filter-item 的统一样式
  .filter-item {
    margin-bottom: 0 !important;
    /* 清除默认的底部边距，由 gap 或容器控制 */
    flex-shrink: 0;
    /* 禁止压缩内容长度 */
  }
}

.comm_but_warp {
  margin-bottom: 5px;
}

.sku-spec {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.batch-query-form {
  margin-top: 18px;
  padding: 14px 14px 0;
  background: #f7f8fa;
  border-radius: 6px;
}

.batch-delivery-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  color: #606266;
}

.batch-express-action {
  display: flex;
  align-items: center;
  gap: 10px;
}

.address-edit-alert {
  margin-bottom: 20px;
}

.batch-delivery-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.offline-import-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.selected-import-file {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}

.selected-import-file span {
  flex: 1;
}

.delivery-form {
  padding: 0 8px;
}

.delivery-tip {
  margin-left: 14px;
  color: #909399;
  font-size: 12px;
}

.package-list {
  display: grid;
  gap: 12px;
}

.package-express-action {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.package-express-action > .el-select {
  flex: 1 1 200px;
  min-width: 0;
}

.package-express-tip {
  margin-top: 6px;
  color: #606266;
  font-size: 12px;
  line-height: 1.6;
}

.package-card {
  padding: 14px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #fafafa;
}

.package-card__header,
.package-card__fields {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.package-card__header {
  margin-bottom: 12px;
}

.package-card__fields > * {
  flex: 1;
}

.package-delete {
  margin-left: 10px;
  color: #f56c6c;
}

.add-package {
  width: 100%;
  margin-top: 12px;
}

.delivery-note {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 4px;
  color: #606266;
  background: #f4f4f5;
  font-size: 12px;
  line-height: 1.6;
}
</style>
